import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';
import { Indication } from '../types';
import styles from './styles';
/* eslint-disable react/require-default-props */
interface IndicationComparisonActionsProps {
  showActions: boolean;
  hasAnyAction: boolean;
  currIndication: Indication | null;
  isCopying: boolean;
  onCopyIndication?: () => void;
  onCopy?: () => void;
  onAcceptCurrent?: () => void;
}
/* eslint-enable react/require-default-props */
const IndicationComparisonActions = ({
  showActions,
  hasAnyAction,
  currIndication,
  isCopying,
  onCopyIndication,
  onCopy,
  onAcceptCurrent
}: IndicationComparisonActionsProps): React.ReactElement | null => {
  if (!showActions || !hasAnyAction) return null;

  return (
    <Box sx={styles.actionsBar}>
      {currIndication == null && onCopyIndication != null && (
        <Button variant='contained' onClick={onCopyIndication} disabled={isCopying}>
          Copy indication to current
        </Button>
      )}
      {currIndication != null && onCopy != null && (
        <Button variant='outlined' onClick={onCopy} disabled={isCopying}>
          Copy Indication from Previous Submission
        </Button>
      )}
      {onAcceptCurrent != null && currIndication != null && (
        <Button variant='contained' onClick={onAcceptCurrent} autoFocus>
          Current Indication Data is Correct
        </Button>
      )}
    </Box>
  );
};

export default IndicationComparisonActions;
